import { Badge } from '@/components/ui/badge'

export function BrandHeader({ senderName }: { senderName?: string }) {
  return (
    <div className="flex items-center justify-between border-b border-border px-8 py-5">
      <span className="text-body font-normal tracking-tight text-foreground">
        {senderName ?? 'Association email'}
      </span>
      <Badge variant="neutral">Brand header · set in Email settings</Badge>
    </div>
  )
}

export function SendTimeFurniture({ postalAddress }: { postalAddress?: string | null }) {
  return (
    <div className="border-t border-dashed border-border px-8 py-4">
      <p className="text-caption text-muted-foreground">
        Added at send time (not editable): recipient provenance · unsubscribe link
        {postalAddress ? ` · ${postalAddress}` : ''}
      </p>
    </div>
  )
}
